// Grade de horários do celular deitado (ver docs/horario/SPEC-horario-landscape.md).
// Cada horário de aula é uma linha fixa; as faixas do almoço (4) e da noite (7) só
// aparecem com eventos extras. Minutos desde 00:00, como no engine.

export const HORARIOS = [
  { row: 2, inicio: 450, fim: 550 },  // 07:30–09:10
  { row: 3, inicio: 570, fim: 670 },  // 09:30–11:10
  { row: 5, inicio: 810, fim: 910 },  // 13:30–15:10
  { row: 6, inicio: 930, fim: 1030 }, // 15:30–17:10
];

export const FAIXAS = {
  4: { inicio: 690, fim: 740 },   // 11:30–12:20
  7: { inicio: 1050, fim: 1150 }, // 17:30–19:10
};

const FAIXA_NOITE_INICIO = 1030; // 17:10: a partir daqui o extra vai pra faixa da noite

// Posição de um evento com horário. Evento que cobre dois horários seguidos vira um card
// só (span 2); turno com duas aulas diferentes são dois cards, cada um na sua linha.
export function posicao(event) {
  const inicio = event.startMinutes;
  const fim = event.endMinutes ?? inicio; // o seminário só tem início
  const cobre = HORARIOS.filter((horario) => inicio < horario.fim && fim > horario.inicio);

  if (cobre.length) {
    const primeiro = cobre[0];
    const ultimo = cobre[cobre.length - 1];
    return {
      row: primeiro.row,
      span: ultimo.row - primeiro.row + 1,
      faixa: false,
      mostrarHorario: inicio !== primeiro.inicio || fim !== ultimo.fim,
    };
  }

  // Fora dos horários de aula: extras (optativa, ATEX, seminário). Só acontecem no almoço
  // ou depois das 17:10.
  const row = inicio >= FAIXA_NOITE_INICIO ? 7 : 4;
  const faixa = FAIXAS[row];
  return { row, span: 1, faixa: true, mostrarHorario: inicio !== faixa.inicio || fim !== faixa.fim };
}

// Evento sem horário (feriado, dia sem aula) ocupa o dia inteiro, do 1º ao 4º horário.
function posicaoDoEvento(event) {
  return Number.isFinite(event.startMinutes)
    ? posicao(event)
    : { row: 2, span: 5, faixa: false, diaTodo: true, mostrarHorario: false };
}

// Organiza os eventos de um dia. Quando dois eventos ocupam alguma linha em comum, viram
// colunas lado a lado (lane) dentro do grupo que se sobrepõe, pra nenhum cobrir o outro.
export function layoutDia(events) {
  const items = events
    .map((event) => ({ event, ...posicaoDoEvento(event) }))
    .sort((a, b) => a.row - b.row || b.span - a.span);

  const grupos = [];
  let fimDoGrupo = -1;
  for (const item of items) {
    if (item.row <= fimDoGrupo) grupos[grupos.length - 1].push(item);
    else grupos.push([item]);
    fimDoGrupo = Math.max(fimDoGrupo, item.row + item.span - 1);
  }

  let lanes = 1;
  for (const grupo of grupos) {
    const fimDaLane = [];
    for (const item of grupo) {
      let lane = fimDaLane.findIndex((fim) => item.row > fim);
      if (lane < 0) {
        lane = fimDaLane.length;
        fimDaLane.push(0);
      }
      fimDaLane[lane] = item.row + item.span - 1;
      item.lane = lane;
    }
    for (const item of grupo) item.lanesDoGrupo = fimDaLane.length;
    lanes = Math.max(lanes, fimDaLane.length);
  }

  const ocupadas = new Set();
  for (const item of items) for (let row = item.row; row < item.row + item.span; row++) ocupadas.add(row);
  const livres = [2, 3, 5, 6].filter((row) => !ocupadas.has(row));

  return { items, livres, lanes };
}

// Faixas só aparecem quando algum evento da semana cai nelas (cobrindo ou não). O dia
// inteiro (feriado) atravessa a faixa do almoço mas não conta: não é evento do almoço.
export function faixasVisiveis(layouts) {
  const cobre = (row) => layouts.some((layout) => layout.items.some((item) =>
    !item.diaTodo && item.row <= row && item.row + item.span - 1 >= row));
  return { almoco: cobre(4), noite: cobre(7) };
}
